import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BasePlace, RestaurantService} from "../../services/restaurant.service";
import {Constants} from "../../utils/constants";
import {NotificationService} from "../../services/common/notification.service";
import {PlaceService} from "../../services/place.service";

@Component({
  selector: 'app-place',
  templateUrl: './place.component.html',
  styleUrls: ['./place.component.scss']
})
export class PlaceComponent implements OnInit {

  @Input() place:BasePlace;
  @Input() restaurantHistoryId:number;
  @Input() isEdit:boolean;

  @Output() onRemove:EventEmitter<any> = new EventEmitter();
  @Output() onDelete:EventEmitter<number> = new EventEmitter();
  @Output() onClose:EventEmitter<any> = new EventEmitter();

  public placeType = Constants.PLACE_TYPES;

  public showDelete:boolean = true;
  constructor(private placeService:PlaceService, private notificationService:NotificationService) { }

  ngOnInit() {
    if(this.isEdit){
      this.showDelete = false;
    }
    if(!this.isEdit) {
      this.isEdit = this.place.id == null;
    }
    if(this.place.saturation<1){this.place.saturation *= 100;}
  }

  finalize() {
    try {
      this.placeService.validate(this.place);
      this.place.saturation /= 100;
      if(this.place.id == null){
        this.placeService.save(this.place).subscribe(place=>{
          this.placeService.attachPlaceToRestaurantHistory(this.restaurantHistoryId, place.id).subscribe(result =>{
            this.notificationService.showSuccess("general.success");
            this.isEdit = false;
            this.place = place;
            this.onClose.emit();
          });
        });
      }else{
        this.placeService.update(this.place).subscribe(place=>{
          this.notificationService.showSuccess("general.success");
          this.isEdit = false;
          this.onClose.emit();
        });
        this.place.saturation *= 100;
      }
    }catch (e) {
      console.log(e);
      this.notificationService.showError(e.message);
    }
  }
  remove(){
    if(this.place.id == null) {
      this.onRemove.emit();
    }else{
      this.onDelete.emit(this.place.id);
      this.onRemove.emit();
    }
  }
}
